'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

exports.default = (0, _utils.processPayment)('/mifinity/withdrawal/process', {
  amount: 'required',
  sessionId: 'required',
  userId: 'required',
  merchantId: 'required'
});